import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Flex,
  Badge,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  VStack,
  HStack,
  useColorModeValue
} from '@chakra-ui/react'
import { FaFileAlt, FaSearch } from 'react-icons/fa'
import { LABEL } from '../../../constants'

const ListModal = ({
  isOpen,
  onClose,
  selectedGroupName,
  selectedArticles
}) => {
  const bg = useColorModeValue('white', 'gray.800')
  const borderColor = useColorModeValue('gray.200', 'gray.700')
  const scrollbarThumb = useColorModeValue('#CBD5E0', '#4A5568')
  const hoverBg = useColorModeValue('gray.50', 'gray.700')

  const [searchTerm, setSearchTerm] = useState('')
  useEffect(() => {
    if (isOpen) setSearchTerm('')
  }, [isOpen])

  const filteredArticles = selectedArticles.filter(a =>
    a.name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent bg={bg} maxW="600px">
        <ModalHeader px={6} pt={6} pb={2}>
          <Text
            fontSize="sm"
            color="gray.500"
            textTransform="uppercase"
            letterSpacing="wide"
          >
           {LABEL.EXPENSE_GROUP_DROPDOWN.label}
          </Text>
          <Flex align="center" justify="space-between" mt={1}>
            <Text
              fontSize="lg"
              fontWeight="semibold"
              color={useColorModeValue('gray.800', 'white')}
            >
              {selectedGroupName}
            </Text>
            <Badge variant="solid" colorScheme="blue" fontSize="sm">
              {selectedArticles.length}
            </Badge>
          </Flex>
        </ModalHeader>
        <ModalCloseButton top={3} right={3} />

        <ModalBody px={6} py={2}>
          <VStack spacing={4} align="stretch" w="100%">
            <InputGroup size="sm">
              <InputLeftElement pointerEvents="none" color="gray.400">
                <FaSearch />
              </InputLeftElement>
              <Input
                placeholder={LABEL.SEARCH.label}
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
            </InputGroup>

            {filteredArticles.length > 0 ? (
              <Box
                w="100%"
                maxH="60vh"
                overflowY="auto"
                css={{
                  '&::-webkit-scrollbar': { width: '6px' },
                  '&::-webkit-scrollbar-thumb': {
                    background: scrollbarThumb,
                    borderRadius: '3px'
                  }
                }}
              >
                <VStack spacing={2} align="stretch">
                  {filteredArticles.map(a => (
                    <HStack
                      key={a.id}
                      w="100%"
                      p={3}
                      borderWidth="1px"
                      borderRadius="md"
                      borderColor={borderColor}
                      _hover={{ bg: hoverBg }}
                    >
                      <Icon as={FaFileAlt} boxSize={5} color="blue.400" />
                      <Text fontSize="sm" fontWeight="medium" noOfLines={1}>
                        {a.name}
                      </Text>
                    </HStack>
                  ))}
                </VStack>
              </Box>
            ) : (
              <Text color="gray.500" textAlign="center" py={10}>
                {searchTerm
                  ? LABEL.ARTICLE_LIST_MODAL.NO_ARTICLE_SEARCH
                  : LABEL.ARTICLE_LIST_MODAL.NO_ARTICLES}
              </Text>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Închide
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ListModal
